// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-filling-constructor-card .p-button {
  padding: 0 17.5px;
  height: 42px;
}

.field-filling-constructor-card .p-multiselect {
  max-width: 40%;
}

.field-filling-constructor-card__row .flex-row {
  border: 2px solid rgb(225, 234, 245);
  border-radius: 8px;
  padding: 2px;
  height: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/FieldFillingControl.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd","sourcesContent":[".field-filling-constructor-card .p-button {\n  padding: 0 17.5px;\n  height: 42px;\n}\n\n.field-filling-constructor-card .p-multiselect {\n  max-width: 40%;\n}\n\n.field-filling-constructor-card__row .flex-row {\n  border: 2px solid rgb(225, 234, 245);\n  border-radius: 8px;\n  padding: 2px;\n  height: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
